import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function OAuthSuccess() {
  const navigate = useNavigate();

useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const token = params.get("token");
  
  if (token) {
    try {
      // トークンを消去してから保存（念のため）
      sessionStorage.removeItem("token");
      sessionStorage.setItem("token", token);
      
      // 保存直後に確認
      const storedToken = sessionStorage.getItem("token");
      
      if (storedToken) {
        // 直接ダッシュボードに遷移
        window.location.href = "/dashboard";
      } else {
        navigate("/login");
      }
    } catch (error) {
      navigate("/login");
    }
  } else {
    navigate("/login");
  }
}, [navigate]);
  

  return <p>ログイン中です...</p>;
}

export default OAuthSuccess;